/**************
 Cart
 ***************/

let vibitRollID = 8143556018456;
let vibitRoll2ID = 9811845415192;
let permafixFootSystemID = 9853873127704;
let permafixFootSystemBasicID = 9906993692952;
let communityAccessID = 9971607044376;

// open cart
async function openCart(skipFetch = false) {
    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");


    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // reset container
    document.querySelector("#miniCartCenterBody").innerHTML = "";

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // check if free gifts product is in cart
    let freeGiftsInCart = cart.items.find(item => item.product_id === 9679307407640);

    // if free product is in cart, remove it
    if (freeGiftsInCart) {

        // update product
        await changeProduct({
            quantity: 0,
            id: freeGiftsInCart.key
        });

        // open cart
        await openCart();

        return;
    }

    // check if roll in cart
    let vibitRollsInCart = cart.items.filter(item => (item.product_id === vibitRollID || item.product_id === vibitRoll2ID));

    // check if community access in cart
    let communityAccessInCart = cart.items.filter(item => item.product_id === communityAccessID);


    // if community access is in cart, but roll isn't, remove
    if (communityAccessInCart.length > 0 && vibitRollsInCart.length === 0) {
        // update product
        await changeProduct({
            quantity: 0,
            id: communityAccessInCart[0].key
        });

        // open cart
        await openCart();

        return;
    }

    // if quantity of community access > 1, set to 1
    // if community access is in cart, but roll isn't, remove
    if (communityAccessInCart.length > 0 && communityAccessInCart[0]?.quantity > 1) {
        // update product
        await changeProduct({
            quantity: 1,
            id: communityAccessInCart[0].key
        });

        // open cart
        await openCart();

        return;
    }


    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    // update count badge (css reads data-count) and keep the screen reader label in sync
    const headerRightCart = document.querySelector("#headerRightCart");
    headerRightCart.dataset.count = cart.item_count;
    headerRightCart.setAttribute("aria-label", `cart - ${cart.item_count} items`);


    // check if vib-ROLL/vib-TENS in cart
    let isVibRollInCart = cart.items.find(item => item.product_id === vibitRoll);
    let isVibTensInCart = cart.items.find(item => item.product_id === vibitTens);


    // show upsells based on key items in cart
    if (isVibRollInCart) {
        // add Toe Spacers Vibit TENS Vibit GUN MAX
        updateUpsells(toeSpacers, vibitTens, vibitGunMax);

    } else if (isVibTensInCart) {
        // add Easy Stick Pads Vibit ROLL Vibit GUN Max
        updateUpsells(easyStickPads, vibitRoll, vibitGunMax);

    } else {
        // add Vibit  ROLL Vibit TENS Vibit GUN Max
        updateUpsells(vibitRoll, vibitTens, vibitGunMax);
    }

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartCenterUpsellsItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        }
    });

    // check if upsells empty (upsells have no active items)
    if (document.querySelectorAll(".miniCartCenterUpsellsItem.active").length === 0) {
        // hide upsells
        document.querySelector("#miniCartCenterUpsells").classList.add("active");
    } else {
        document.querySelector("#miniCartCenterUpsells").classList.remove("active");
    }

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartCenterBody").classList.remove("active");
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        document.querySelector("#miniCartCenterUpsellsTitle").textContent = "Or get started here";

        return;
    }

    // show main cart sections
    document.querySelector("#miniCartCenterBody").classList.add("active");
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartFooter").classList.add("active");
    document.querySelector("#miniCartCenterUpsellsTitle").textContent = "You might also like";

    // update total price
    document.querySelector("#miniCartFooterUpperTotalFinal").textContent = price(cart.total_price);

    // calculate the maximum compare at price
    let totalComparePrice = 0;
    cart.items.forEach(item => {
        let comparePrice = cartData[item.key].compare_at_price;

        // to show the customer that they're saving the MOST possible
        // we want to calculate the largest compare at price possible
        // this means we're going to use the largest of the 2
        // 1) Compare at price * quantity
        // 2) Original line price
        // The reason we can't ALWAYS use (1) is because not all products have a compare at price
        if (comparePrice > item.original_price) {
            totalComparePrice += comparePrice * item.quantity;
        } else {
            totalComparePrice += item.original_line_price;
        }
    });

    // if the compare at price
    if (totalComparePrice > cart.total_price) {
        document.querySelector("#miniCartFooterUpperTotalOG").classList.add('active');
        document.querySelector("#miniCartFooterUpperTotalFinal").classList.add("active");
        document.querySelector("#miniCartFooterUpperTotalOG").textContent = price(totalComparePrice);

    } else {
        document.querySelector("#miniCartFooterUpperTotalOG").classList.remove('active');
        document.querySelector("#miniCartFooterUpperTotalFinal").classList.remove("active");
    }


    // append cart
    cart.items.forEach(function (item) {
        // variant HTML
        function variantHTML() {
            // loop over options_with_values
            let options = "";
            options += `<div class="miniCartCenterBodyItemVariant">`;
            item.options_with_values.forEach(function (option) {
                options += `${option.value}<br>`;
            });
            options += `</div>`;

            // check for Default
            if (options.includes("Default Title")) {
                return ""
            }

            return options;
        }

        // ship date for oversold items, set as the Ships line item property on the PDP
        function shipsHTML() {
            if (!item.properties || !item.properties.Ships) {
                return "";
            }

            return `<div class="miniCartCenterBodyItemShips">Ships: ${item.properties.Ships}</div>`;
        }

        // discount HTML
        function discountHTML() {
            let HTML = "";

            // check for discount
            if (item.line_level_discount_allocations.length === 0) {
                return "";
            }

            item.line_level_discount_allocations.forEach(discount => {
                HTML = `<div class="miniCartBodyItemDiscount">
                         <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="M856-390 570-104q-12 12-27 18t-30 6q-15 0-30-6t-27-18L103-457q-11-11-17-25.5T80-513v-287q0-33 23.5-56.5T160-880h287q16 0 31 6.5t26 17.5l352 353q12 12 17.5 27t5.5 30q0 15-5.5 29.5T856-390ZM513-160l286-286-353-354H160v286l353 354ZM260-640q25 0 42.5-17.5T320-700q0-25-17.5-42.5T260-760q-25 0-42.5 17.5T200-700q0 25 17.5 42.5T260-640Zm220 160Z"/></svg>
                         ${discount.discount_application.title}
                         </div>`;
            });


            return HTML;
        }

        function priceHTML() {
            // start HTML string
            let html = "";
            let comparePrice = cartData[item.key].compare_at_price

            // check if final_line_price is 0, if so use original_line_price (this happens when you add a gift and above the threshold) else use final_line_price
            if (item.final_line_price === 0) {
                html += ` <span>FREE</span>`;
            } else {
                html += `<span>${price(item.final_line_price)}</span>`;
            }

            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                html += `<s>${price(item.selling_plan_allocation.compare_at_price * item.quantity)}</s>`;
            }
            // check for line item discount
            else if (item.original_line_price > item.final_line_price) {
                html += `<s>${price(item.original_line_price)}</s>`;
            }
            // check for compare at price
            else if (comparePrice) {
                html += `<s>${price(comparePrice * item.quantity)}</s>`;
            }

            return html;
        }

        function hiddenButtonsClass() {
            // start HTML string
            let className = "";

            // if this is the vibit roll, don't show quantity buttons
            // unless we're hiding the free gift banner
            let hideFreeGiftBanner = item.properties && item.properties._hide_free_gift_banner === 'true';
            if ((item.product_id === vibitRollID || item.product_id === vibitRoll2ID || item.product_id === communityAccessID) && !hideFreeGiftBanner) {
                className += "hiddenButtons hiddenQty";
            }

            return className;
        }

        // Shows gift banner
        function giftHTML() {
            let HTML = ``;

            // exit if _hide_free_gift_banner property is set to true
            if (item.properties && item.properties._hide_free_gift_banner === 'true') {
                return HTML;
            }

            // if (item.product_id === vibitRollID || item.product_id === vibitRoll2ID || item.product_id === permafixFootSystemID || item.product_id === permafixFootSystemBasicID) {
            if (item.product_id === vibitRollID || item.product_id === vibitRoll2ID) {
                let price = (item.product_id === permafixFootSystemID || item.product_id === permafixFootSystemBasicID) ? '299' : '200';
                HTML = `
                 <div class="miniCartCenterBodyItemGift">
                     <img class="miniCartCenterBodyItemGiftIcon" src="https://cdn.shopify.com/s/files/1/0719/6717/9032/files/25.2.20_Website_Free_Gift_Assets_1.png?v=1741022799&width=400" alt="Gifts">
                     <div class="miniCartCenterBodyItemGiftTxt">+ FREE Gifts (Total Value of $${price})</div>
                 </div> 
                 `
            }
            return HTML;
        }


        // Shows an add button for the vibit roll if it has a quantity of 1
        function upgradeHTML() {
            let HTML = ``;

            // check if there are more than 1 of the vibit roll in cart
            let vibitRollsInCart = cart.items.filter(item => (item.product_id === vibitRollID || item.product_id === vibitRoll2ID));

            if ((item.product_id === vibitRollID || item.product_id === vibitRoll2ID) && item.quantity === 1 && vibitRollsInCart.length === 1) {
                HTML = `
                 <button class="miniCartCenterBodyItemUpgrade button" data-id="${item.id}">ADD ANOTHER VIBIT FOR $66</button>
                 `
            }
            return HTML;
        }

        // Prevents user from using the product links
        function noSelectCSS() {
            let CSS = ``;
            // Free Gifts 9679307407640
            // tutorial access 9602736423192, 9031323648280, 8231080755450

            let noSelectProductIDs = [9679307407640, 9602736423192, 9031323648280];

            if (noSelectProductIDs.includes(item.product_id)) {
                CSS = `noSelect`;
            }
            return CSS;
        }

        let productTitle = item.product_title;
        if (item.product_id === vibitRoll2ID) {
            productTitle = productTitle.trim().replace(/\s\d$/, '');
        }

        /**
         * Builds the HTML for the components of a product (if they exist) and returns it.
         * Components are used for bundles and show the individual products that make up the bundle.
         * @returns {string}
         */
        function componentsHTML() {
            let HTML = ``;
            let components = cartData[item.key].components;

            if (components.length === 0) {
                return HTML;
            }


            HTML += `<div class="miniCartCenterBodyItemComponents">`;
            components.forEach(component => {
                HTML += `
                <div class="miniCartCenterBodyItemComponentsItem">
                    <img class="miniCartCenterBodyItemComponentsItemImg" src="${component.image}" alt="${component.title}" >
                    <div class="miniCartCenterBodyItemComponentsItemTxt">${component.quantity} x ${component.title}</div>
                </div>
                 `;
            })
            HTML += `</div>`;

            return HTML;
        }


        document.querySelector("#miniCartCenterBody").insertAdjacentHTML("beforeend", `
             <div class="miniCartCenterBodyItem" key="${item.key}">
                 <a class="${noSelectCSS()}" href="${item.url}">
                     <img class="miniCartCenterBodyItemImage" src="${item.image}&width=200" alt="${productTitle}">
                 </a>
                 <div>
                     <div class="miniCartCenterBodyItemRow">
                         <a class="${noSelectCSS()}" href="${item.url}">
                             <div class="miniCartCenterBodyItemRowTitle">${productTitle}</div>
                         </a>
                         <button class="miniCartCenterBodyItemRowRemove">
                             <svg class="miniCartCenterBodyItemRowRemoveImg" focusable="false" data-prefix="far" data-icon="trash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z"></path></svg>
                         </button>
                     </div>
                   
                     ${variantHTML()}
                     ${shipsHTML()}
                     <div class="miniCartCenterBodyItemBottom">
                         ${(item.product_id != permafixFootSystemID && item.product_id != permafixFootSystemBasicID) ? giftHTML() : ''}
                         <div class="miniCartCenterBodyItemBottomQty ${hiddenButtonsClass()}">
                             <button class="miniCartCenterBodyItemBottomQtyMinus">
                                 <svg aria-hidden="true" class="miniCartCenterBodyItemBottomQtyMinusSVG" focusable="false" data-prefix="far" data-icon="minus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"></path></svg>
                             </button>
                             <div class="miniCartCenterBodyItemBottomQtyCount">${item.quantity}</div>
                             <button class="miniCartCenterBodyItemBottomQtyPlus">
                                 <svg aria-hidden="true" class="miniCartCenterBodyItemBottomQtyPlusSVG" focusable="false" data-prefix="far" data-icon="plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"></path></svg>
                             </button>
                         </div>
                         <div class="miniCartCenterBodyItemBottomPrice">${priceHTML()}</div>           
                   </div>
                   ${discountHTML()}
                   
                    ${componentsHTML()}
                    
                 </div>
               
                 ${upgradeHTML()}
              </div>
         `);

    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartCenterBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartCenterBodyItemBottomQtyCount").textContent);

        // minus
        element.querySelector(".miniCartCenterBodyItemBottomQtyMinus").addEventListener("click", async function () {

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");
            if (quantity === 1) {
                element.querySelector(".miniCartCenterBodyItemRowRemove").click();
            } else {
                // temporarily disable button
                this.disabled = true;

                quantity--;
                await updateCartItem();

                // enable button
                this.disabled = false;
            }
        });

        // plus
        element.querySelector(".miniCartCenterBodyItemBottomQtyPlus").addEventListener("click", async function () {

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // temporarily disable button
            this.disabled = true;

            quantity++;
            await updateCartItem();

            // enable button
            this.disabled = false;
        });

        // remove
        element.querySelector(".miniCartCenterBodyItemRowRemove").addEventListener("click", async function () {
            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // temporarily disable all remove button
            document.querySelectorAll(".miniCartCenterBodyItemRowRemove").forEach(button => {
                button.disabled = true;
            });

            quantity = 0;
            await updateCartItem();

            // enable all remove button
            document.querySelectorAll(".miniCartCenterBodyItemRowRemove").forEach(button => {
                button.disabled = false;
            });

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartCenterBodyItemBottomQtyCount`).textContent = quantity;


            // update cart in shopify
            let response = await changeProduct({
                id: key,
                quantity: quantity
            });

            // check for error
            if (!response) {
                await openCart();
                return
            }

            // update cart
            cart = response;

            // update active body
            await openCart(true);
        }
    });

    // upgrade button event listener
    document.querySelectorAll(".miniCartCenterBodyItemUpgrade").forEach(function (element) {
        element.addEventListener("click", async function () {
            // add loading animation
            this.classList.add("loading");

            // create form data
            let formData = {
                items: [{
                    quantity: 1,
                    id: parseInt(this.dataset.id)
                }]
            };

            // add product upsell
            await addProduct(formData);

            // remove loading animation
            this.classList.remove("loading");

            await openCart();
        });
    })
}


// update upsells
function updateUpsells(...upsellIds) {
    // clear upsells
    document.querySelectorAll(".miniCartCenterUpsellsItem").forEach(element => {
        element.classList.remove("active");
    });

    // for each upsell
    upsellIds.forEach(function (id) {
        // get the upsell
        let upsell = document.querySelector(`.miniCartCenterUpsellsItem[data-product="${id}"]`);
        // add active class to show it
        upsell?.classList.add("active");
    });
}

// Add Upsell function
document.querySelectorAll('.miniCartCenterUpsellsItemWrapATC').forEach(function (element) {
    element.addEventListener("click", async function () {
        // get variant ID from dropdown selector
        const variantID = this.closest('.miniCartCenterUpsellsItem').querySelector('.miniCartCenterUpsellsItemChoice').value;

        // add loading animation
        this.classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        await openCart();
    });
});

// close cart
function closeCart() {
    document.querySelector("#miniCart").close();
    document.querySelector("body").classList.remove("noScroll");
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", async function () {
        await openCart();
    });
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {

    // if vibit tens in cart, show upsell
    if (false && window.ab_upsell === true && Shopify.shop === "vibit-com-au.myshopify.com") {
        if (cart.items.find(item => item.product_id === 7730217386234)) {
            await openUpsell();
        }
    }

    let vibitRollsInCart = cart.items.filter(item => (item.product_id === vibitRollID || item.product_id === vibitRoll2ID));
    let permafixFootSystemsInCart = cart.items.filter(item => (item.product_id === permafixFootSystemID));
    let permafixFootSystemsBasicInCart = cart.items.filter(item => (item.product_id === permafixFootSystemBasicID));

    // if the roll is in cart, add the free gifts product
    if (vibitRollsInCart.length > 0) {
        let formData = {
            items: [{
                quantity: 1,
                id: 49838321369368
            }]
        };

        await addProduct(formData);
    }

    // if the permafixFootSystem is in cart, add the free gifts product
    // if (permafixFootSystemsInCart.length > 0 || permafixFootSystemsBasicInCart.length > 0) {
    //     let formData = {
    //         items: [{
    //             quantity: 1,
    //             id: 50629989925144
    //         }]
    //     };

    //     await addProduct(formData);
    // }

    window.location.href = "/checkout";
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));


/**************************** Upsell ****************************/

// Open upsell
async function openUpsell() {
    document.querySelector("#upsell").showModal();
    document.querySelector("body").classList.add("noScroll");


    await new Promise((resolve, reject) => {
        document.querySelector(`#upsell`).addEventListener("close", function (e) {
            resolve('closed');
        });
    });
}

// Upsell ATC
document.querySelector('#upsellContentBodyControlsATC').addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");

    // create form data
    let formData = {
        items: [{
            quantity: 1,
            id: parseInt(this.dataset.id)
        }]
    };

    // add product upsell
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    closeUpsell();
});


// close upsell event
document.querySelector("#upsell").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close upsell
function closeUpsell() {
    document.querySelector("#upsell").close();
}

// close upsell event listener
document.querySelectorAll(".closeUpsell").forEach(function (element) {
    element.addEventListener("click", closeUpsell);
});


document.querySelector("#upsell").addEventListener("click", function (e) {
    if (e.target === this) {
        closeUpsell();
    }
})


/* <div class="cart__footer">
  <label style="display:block;margin-bottom:10px;">
    <input type="checkbox" id="shipping-insurance-checkbox" />
    Add Shipping Insurance ($3.42)
  </label>

  {{ cart.total_price | money }}
  <button type="submit">Checkout</button>
</div> */
 